import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CheckPicker, Col, FlexboxGrid, FormGroup, HelpBlock, Icon, IconButton, Tag, Tooltip, Whisper } from 'rsuite';
import { changeNoCacheValue, getItensFiltro, getLatLon, searchEndereco, setErro, setSingleReducer } from '../../../../../actions/actionsPainelGeral';

import { LoadingMenu } from '../../../../../components/LoadingSpinner';
import { AddressRadiusFilter } from './AddressRadiusFilter';

const TAG_STYLE = {
  padding: '5px 10px',
  marginRight: '10px',
  width: '100%',
  textAlign: 'center',
  border: '2px solid #3597fa',
  color: '#3597fa',
};

/** CheckPicker filters that load data without open/search callbacks (server-driven list). */
const CHECKPICKER_NAMES_WITHOUT_OPEN_OR_SEARCH = new Set(['pmc', 'rebaixaPreco', 'marcaPropria']);

class CustomFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timer: null,
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.changeEndereco = this.changeEndereco.bind(this);
    this.selectEndereco = this.selectEndereco.bind(this);
    this.selectRaio = this.selectRaio.bind(this);
    this.handleClean = this.handleClean.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    const { filtro, dataList, endereco, raio } = this.props;

    return nextProps.filtro !== filtro || nextProps.dataList !== dataList || nextProps.endereco !== endereco || nextProps.raio !== raio;
  }

  changeEndereco(value) {
    const { searchEndereco, endereco, changeNoCacheValue } = this.props;

    searchEndereco({ query: value, token: endereco.token });
    changeNoCacheValue('endereco', value);
  }

  selectEndereco(item) {
    const { getLatLon, endereco, changeNoCacheValue, setErro } = this.props;

    getLatLon({
      place_id: item.place_id,
      token: endereco.token,
    });
    changeNoCacheValue('endereco', item.value);

    if (endereco?.erro?.length) {
      setErro(null, 'endereco');
      const wrongEndereco = document.getElementsByName('endereco')[0];
      wrongEndereco.classList.remove('invalid-input');
    }
  }

  selectRaio(value) {
    const { changeNoCacheValue } = this.props;
    changeNoCacheValue('raio', value);
  }

  handleSelect(value, i, name) {
    const { setSingleReducer, dataList } = this.props;
    const hasValue = dataList.value.includes(i.value);

    if (hasValue) {
      const removeCache = dataList.cache.filter(item => i.value !== item.value);
      setSingleReducer(name, value, removeCache);
    } else {
      const addCache = [...dataList.cache, i];
      setSingleReducer(name, value, addCache);
    }
  }

  handleClean(name) {
    const { setSingleReducer } = this.props;
    setSingleReducer(name, [], []);
  }

  render() {
    const { filtro, index, handleDeleteFiltro, raio, endereco, dataList, onOpenCustomFilter, onSearchCustomFilter } = this.props;
    const ERROR_MESSAGE = filtro?.erro !== null && filtro?.erro !== undefined ? filtro?.erro : null;
    const skipPickerOpenAndSearch = CHECKPICKER_NAMES_WITHOUT_OPEN_OR_SEARCH.has(filtro?.name);
    const onOpen = skipPickerOpenAndSearch ? undefined : () => onOpenCustomFilter('', filtro);
    const onSearch = skipPickerOpenAndSearch || !filtro.onSearch ? null : search => onSearchCustomFilter(search, filtro);

    return (
      <>
        {filtro?.tipoCampo === 1 ? (
          <FlexboxGrid.Item componentClass={Col} lg={11} md={9} style={{ marginBottom: '0' }} xsHidden smHidden>
            <FlexboxGrid.Item componentClass={Col} lg={4} md={6}>
              <Tag style={TAG_STYLE}>{filtro.title}</Tag>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={16} md={13} sm={23} xs={23} style={{ marginLeft: '10px' }}>
              <FormGroup>
                <CheckPicker
                  block
                  className="inf-picker"
                  disabledItemValues={[filtro.name].disabled}
                  cleanable={filtro.cleanable}
                  searchable={filtro.searchable}
                  filter={false}
                  data={dataList?.lista}
                  value={dataList?.value}
                  name={filtro.name}
                  placeholder={filtro.placeholder}
                  locale={filtro.locale}
                  onClean={() => this.handleClean(filtro.name)}
                  onSelect={(value, i) => (filtro.onSelect ? this[filtro.onSelect](value, i, filtro.name) : this.handleSelect(value, i, filtro.name))}
                  onSearch={onSearch}
                  onOpen={onOpen}
                  renderMenu={menu => (
                    <span>
                      <LoadingMenu area="panel-filter" />
                      {menu}
                    </span>
                  )}
                />
                <HelpBlock className="panel-custom-filter-error" name="noDataFilterWarning">
                  {ERROR_MESSAGE}
                </HelpBlock>
              </FormGroup>
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} xs={1}>
              {filtro?.tooltipMessage ? (
                <Whisper
                  placement="top"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      <p>{filtro.tooltipMessage}</p>
                    </Tooltip>
                  }
                >
                  <Icon className="tooltip-info" icon="info" />
                </Whisper>
              ) : null}
            </FlexboxGrid.Item>
            <FlexboxGrid.Item componentClass={Col} lg={2} md={3}>
              <IconButton style={{ marginLeft: '10px' }} icon={<Icon icon="trash2" />} onClick={() => handleDeleteFiltro(index, filtro.name)} />
            </FlexboxGrid.Item>
          </FlexboxGrid.Item>
        ) : null}

        {filtro?.tipoCampo === 2 ? (
          <AddressRadiusFilter
            filtro={filtro}
            endereco={endereco}
            raio={raio}
            onChangeAddress={this.selectEndereco}
            onInputChangeAddress={this.changeEndereco}
            onSelectRaio={this.selectRaio}
            onCleanRaio={() => this.handleClean('raio')}
            onClickRemove={() => handleDeleteFiltro(index, filtro.name)}
          />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (store, props) => ({
  endereco: store.painelGeralDataReducer.endereco,
  raio: store.painelGeralDataReducer.raio,
  dataList: store.painelGeralDataReducer[props.filtro.name],
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getItensFiltro,
      searchEndereco,
      getLatLon,
      setErro,
      setSingleReducer,
      changeNoCacheValue,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(CustomFilter);
